var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaletag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sell_16dp_000000_FILL0_wght400_GRAD0_opsz20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WordPress-Global-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-282.000000, -597.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sell_16dp_000000_FILL0_wght400_GRAD0_opsz20",
    transform: "translate(282.000000, 597.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5625,9.6875 L9.70833333,15.5625 C9.55555556,15.7152778 9.38888889,15.8263889 9.20833333,15.8958333 C9.02777778,15.9652778 8.84027778,16 8.64583333,16 C8.45138889,16 8.26388889,15.9652778 8.08333333,15.8958333 C7.90277778,15.8263889 7.73611111,15.7152778 7.58333333,15.5625 L0.43125,8.41041667 C0.282638889,8.26180556 0.173611111,8.09798611 0.104166667,7.91895833 C0.0347222222,7.73993056 0,7.55166667 0,7.35416667 L0,1.5 C0,1.0875 0.146875,0.734375 0.440625,0.440625 C0.734375,0.146875 1.0875,0 1.5,0 L7.35416667,0 C7.54736111,0 7.73458333,0.0347222222 7.91583333,0.104166667 C8.09694444,0.173611111 8.26201389,0.282638889 8.41104167,0.43125 L15.5625,7.58333333 C15.7152778,7.73611111 15.8263889,7.89930556 15.8958333,8.07291667 C15.9652778,8.24652778 16,8.43055556 16,8.625 C16,8.81944444 15.9651389,9.00756944 15.8954167,9.189375 C15.8256944,9.37104167 15.7147222,9.53708333 15.5625,9.6875 Z M8.64583333,14.5 L14.5,8.64583333 L7.35416667,1.5 L1.5,1.5 L1.5,7.35416667 L8.64583333,14.5 Z M3.5,4.75 C3.84722222,4.75 4.14236111,4.62847222 4.38541667,4.38541667 C4.62847222,4.14236111 4.75,3.84722222 4.75,3.5 C4.75,3.15277778 4.62847222,2.85763889 4.38541667,2.61458333 C4.14236111,2.37152778 3.84722222,2.25 3.5,2.25 C3.15277778,2.25 2.85763889,2.37152778 2.61458333,2.61458333 C2.37152778,2.85763889 2.25,3.15277778 2.25,3.5 C2.25,3.84722222 2.37152778,4.14236111 2.61458333,4.38541667 C2.85763889,4.62847222 3.15277778,4.75 3.5,4.75 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaletag);
export default __webpack_public_path__ + "static/media/saletag.e663dc1d189f9b930fdd287eb4ec88d6.svg";
export { ForwardRef as ReactComponent };